/****************************************************************
Alexander Self
3/30/20

****************************************************************/
import React from 'react';
import moment from 'moment';
import background from '../../../img/user-profile-bg.jpg';
import user from '../../../img/user-fa.png';
import { findEmployeeByName } from '../../../utils';

const ContentHeader = ({ employee, employees, fetchEmployeeProfileByName }) => {
  let hireDate = moment(employee.hireDate).toNow().split(' ');
  return (
    <div id="field-page-header" className="card">
      <div className="card-image waves-effect waves-block waves-light">
        <img className="activator" src={background} alt="background" />
      </div>
      <figure className="hide-on-small-only card-profile-image">
        <img src={user} className="circle z-depth-2 responsive-img activator" alt="profile" />
        <center><h5>{ employee.eid }</h5></center>
      </figure>
      <div className="hide-on-small-only card-content">
        <div className="row">
          <div className="col s3 offset-s2">
            <h4 className="card-title grey-text text-darken-4">{ employee.firstName } { employee.lastName }</h4>
            <p className="medium-small grey-text">{ employee.positionTitle }</p>
          </div>
          <div className="col s2 center-align">
            <h4 className="card-title grey-text text-darken-4">
              { hireDate ? `${hireDate[1]}+ ${hireDate[2]}` : '' }
            </h4>
            <p className="medium-small grey-text">Work Experience</p>
          </div>
          <div className="col s2 center-align">
            <h4 className="card-title grey-text text-darken-4">{ employee.department }</h4>
            <p className="medium-small grey-text">Department</p>
          </div>
          <div className="col s2 center-align">
            <h4 className="card-title grey-text text-darken-4 hoverable pointer"
              onClick={() => fetchEmployeeProfileByName(findEmployeeByName(`${employee.manager.firstName} ${employee.manager.lastName}`, employees))}>
              { employee.manager ? <div>{ employee.manager.firstName } { employee.manager.lastName }</div> : '' }
            </h4>
            <p className="medium-small grey-text">Manager</p>
          </div>
          <div className="col s1 right-align">
            <a className="btn-floating activator waves-effect waves-light amber darken-2 right field-clickview">
              <i className="material-icons">assessment</i>
            </a>
          </div>
        </div>
      </div>
      <div className="show-on-small hide-on-med-and-up">
        <div className="row">
          <div className="col s12 center-align">
            <h4 className="card-title grey-text text-darken-4">{ employee.firstName } { employee.lastName }</h4>
            <p className="medium-small grey-text">{ employee.positionTitle }</p>
          </div>
          <div className="col s12 center-align">
            <h4 className="card-title grey-text text-darken-4">
              { hireDate ? `${hireDate[1]}+ ${hireDate[2]}` : '' }
            </h4>
            <p className="medium-small grey-text">Work Experience</p>
          </div>
          <div className="col s12 center-align">
            <h4 className="card-title grey-text text-darken-4">{ employee.department }</h4>
            <p className="medium-small grey-text">Department</p>
          </div>
          <div className="col s12 center-align">
            <h4 className="card-title grey-text text-darken-4">{ employee.manager ? <div>{ employee.manager.firstName } { employee.manager.lastName }</div> : '' }</h4>
            <p className="medium-small grey-text">Manager</p>
          </div>
          <div className="col s11 right-align">
            <a className="btn-floating activator waves-effect waves-light pink darken-2 right field-clickview">
              <i className="material-icons">assessment</i>
            </a>
          </div>
        </div>
      </div>
      <div className="card-reveal">
        <p>
          <span className="card-title grey-text text-darken-4">
            { employee.firstName } { employee.lastName }
            <i className="material-icons right">close</i>
          </span>
          <span>
            <i className="material-icons cyan-text">perm_identity</i>
            <span className="pl-1">{ employee.positionTitle }</span>
          </span>
        </p>
        <p>
          <span>
            <i className="material-icons cyan-text">description</i>
            <span className="pl-1">{ employee.positionType }, { employee.grade ? `Grade ${employee.grade}` : '' } { employee.subgrade ? employee.subgrade : '' }</span>
          </span>
        </p>
        <p>
          <span>
            <i className="material-icons cyan-text">perm_phone_msg</i>
            <span className="pl-1">{ employee.phone ? employee.phone : employee.mobilePhone ? employee.mobilePhone : 'N/A' }</span>
          </span>
        </p>
        <p>
          <span>
            <i className="material-icons cyan-text">email</i>
            <span className="pl-1">{ employee.email ? employee.email : 'N/A' }</span>
          </span>
        </p>
        <p>
          <span>
            <i className="material-icons cyan-text">location_on</i>
            <span className="pl-1">{
                employee.location === '60' ? `${employee.location} - California`
              : employee.location === '70' ? `${employee.location} - Admin`
              : employee.location === '71' ? `${employee.location} - Ka'u`
              : employee.location === '72' ? `${employee.location} - Kea'au`
              : employee.location === '92' ? `${employee.location} - Hilo`
              : 'N/A'
            }</span>
          </span>
        </p>
      </div>
    </div>
  )
}

export default ContentHeader;



























/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/view/employee_content_header.js